import { EmbedSettingsContent } from './embed-settings-content';

export { EmbedSettingsContent };
